// extracted by mini-css-extract-plugin
export default {"icon":"ContactGrid_icon__OJvOD"};